import { render, staticRenderFns } from "./traningDetail.vue?vue&type=template&id=2a032bfe"
import script from "./traningDetail.vue?vue&type=script&lang=js"
export * from "./traningDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a032bfe')) {
      api.createRecord('2a032bfe', component.options)
    } else {
      api.reload('2a032bfe', component.options)
    }
    module.hot.accept("./traningDetail.vue?vue&type=template&id=2a032bfe", function () {
      api.rerender('2a032bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/traningDetail.vue"
export default component.exports